import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundcents'
})
export class RoundcentsPipe implements PipeTransform {

  transform(num: string|number): string|number {	
		let rawvalue = null;
		if ( typeof num === "number" ){
			rawvalue = num;
		}
		else if (  typeof num === "string" ){
			if ( num.indexOf('$') !== -1 ){
				num = num.replace(/\$/g,'');
			}
			rawvalue = parseFloat(num);
		}
		else {
			return '';
		}
		if ( isNaN(rawvalue) ){
			return num;
		}
		let floorvalue = Math.floor(rawvalue);
		let deci = rawvalue - Math.floor(rawvalue);
		deci = Math.round ( deci * 100 );

		// Plus 1 if overflow decimal
		if ( deci === 100 ){
			floorvalue = floorvalue + 1;
		}

		let text = floorvalue.toString()
		text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return '$'+text;
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/roundcents.pipe.ts